import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, Notification, serializeNotification } from '@agilox/common';

@Injectable()
export class AdminNotificationService {
	private httpClient = inject(HttpClient);
	private environment = inject(ENVIRONMENT);

	createNotification(notification: Notification): Observable<Notification> {
		return this.httpClient.post<Notification>(
			this.environment.serverNew + '/user/v1/notifications',
			serializeNotification(notification)
		);
	}

	updateNotification(notification: Notification): Observable<Notification> {
		return this.httpClient.patch<Notification>(
			this.environment.serverNew + `/user/v1/notifications/${notification.id}`,
			serializeNotification(notification)
		);
	}

	deleteNotification(id: string): Observable<any> {
		return this.httpClient.delete(this.environment.serverNew + `/user/v1/notifications/${id}`);
	}
}
